/* EDIT VARIABLE */
export const EDIT_BAND_NAME = "EDIT_BAND_NAME";
export const editBandName = (bandName) => ({
  type: EDIT_BAND_NAME,
  bandName,
});

export const EDIT_BAND_DESC = "EDIT_BAND_DESC";
export const editBandDesc = (desc) => ({
  type: EDIT_BAND_DESC,
  desc,
});

export const EDIT_BAND_LOCATION = "EDIT_BAND_LOCATION";
export const editBandLocation = (location) => ({
  type: EDIT_BAND_LOCATION,
  location,
});

export const EDIT_BAND_GENRE1 = "EDIT_BAND_GENRE1";
export const editBandGenre1 = (genre1) => ({
  type: EDIT_BAND_GENRE1,
  genre1,
});

export const EDIT_BAND_GENRE2 = "EDIT_BAND_GENRE2";
export const editBandGenre2 = (genre2) => ({
  type: EDIT_BAND_GENRE2,
  genre2,
});

export const EDIT_BAND_IS_SECOND_GENRE = "EDIT_BAND_IS_SECOND_GENRE";
export const editBandIsSecondGenre = (isSecondGenre) => ({
  type: EDIT_BAND_IS_SECOND_GENRE,
  isSecondGenre,
});

export const EDIT_BAND_PICTURE = "EDIT_BAND_PICTURE";
export const editBandPicture = (bandPicture) => ({
  type: EDIT_BAND_PICTURE,
  bandPicture
});

export const EXPORT_BAND_INFO = "EXPORT_ALL";
export const exportBandInfo = (bandInfo, reviewInfo) => ({
  type: EXPORT_BAND_INFO,
  bandInfo,
  reviewInfo
});

export const LOAD_BAND_INFO = "LOAD_BAND_INFO";
export const loadBandInfo = () => ({
  type: LOAD_BAND_INFO,
});

export const LOAD_BAND_INFO_SUCCESS = "LOAD_BAND_INFO_SUCCESS";
export const loadBandInfoSuccess = () => ({
  type: LOAD_BAND_INFO_SUCCESS,
});

export const LOAD_BAND_INFO_FAILURE = "LOAD_BAND_INFO_FAILURE";
export const loadBandInfoFailure = () => ({
  type: LOAD_BAND_INFO_FAILURE,
});

export const SAVE_BAND_BEGIN = "SAVE_BAND_BEGIN";
export const saveBandBegin = () => ({
  type: SAVE_BAND_BEGIN,
});

export const SAVE_BAND_FAILED = "SAVE_BAND_FAILED";
export const saveBandFailed = () => ({
  type: SAVE_BAND_FAILED,
});

export const SAVE_BAND_SUCCESS = "SAVE_BAND_SUCCESS";
export const saveBandSuccess = (band_picture_url) => ({
  type: SAVE_BAND_SUCCESS,
  band_picture_url
});

export const CHANGE_PICTURE_CROP = "CHANGE_CROP_RECTANGLE";
export const changePictureCrop = (pictureCrop) => ({
  type: CHANGE_PICTURE_CROP,
  pictureCrop,
});
